var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      staticClass: "step",
      attrs: { novalidate: "" },
      on: {
        submit: function($event) {
          $event.preventDefault()
          return _vm.submit.apply(null, arguments)
        }
      }
    },
    [
      _c(
        "div",
        { staticClass: "step-row" },
        [
          _c("input-field", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: "required",
                expression: "'required'"
              }
            ],
            staticClass: "field_large",
            attrs: {
              name: "fund-name",
              label: _vm.i18n.sale_campaign_name(),
              placeholder: _vm.i18n.sale_campaign_name_label(),
              errorMessage: _vm.errorMessage("fund-name")
            },
            model: {
              value: _vm.form.name,
              callback: function($$v) {
                _vm.$set(_vm.form, "name", $$v)
              },
              expression: "form.name"
            }
          }),
          _vm._v(" "),
          _vm._l(_vm.schema.rows, function(row, i) {
            return [
              _c(
                "div",
                { key: i, staticClass: "step__row" },
                [
                  _vm._l(row, function(item) {
                    return [
                      item.field === "file"
                        ? _c("file-field", {
                            key: item.id,
                            staticClass: "step__file-field",
                            attrs: {
                              fileType: item.fileType,
                              private: item.private,
                              label: item.label,
                              type: item.type,
                              id: item.id,
                              fieldType: item.fieldType,
                              disableField: _vm.loadVideoId
                            },
                            on: {
                              "file-delete": function($event) {
                                return _vm.fileDelete()
                              }
                            },
                            model: {
                              value: _vm.documents[item.type],
                              callback: function($$v) {
                                _vm.$set(_vm.documents, item.type, $$v)
                              },
                              expression: "documents[item.type]"
                            }
                          })
                        : _vm._e()
                    ]
                  })
                ],
                2
              )
            ]
          }),
          _vm._v(" "),
          _c("div", { staticClass: "text_small text_margin" }, [
            _vm._v(" " + _vm._s(_vm.i18n.tx_blocks_separator()) + " ")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "container_40 step-row__video video" }, [
            _c("div", { staticClass: "step-row__title text_small" }, [
              _vm._v(" " + _vm._s(_vm.i18n.sale_video_title()) + " ")
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "video__add" },
              [
                _c("input-field", {
                  staticClass: "video__add-input",
                  attrs: {
                    name: "sale-campaign-name",
                    id: "sale-campaign-name",
                    placeholder: _vm.i18n.sale_video_past()
                  },
                  on: {
                    input: function($event) {
                      return _vm.setVideoPreview()
                    }
                  },
                  model: {
                    value: _vm.videoPreview,
                    callback: function($$v) {
                      _vm.videoPreview = $$v
                    },
                    expression: "videoPreview"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _vm.videoError
              ? _c("div", { staticClass: "text_description text_small" }, [
                  _vm._v(_vm._s(_vm.i18n.sale_video_preview_error()))
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "text_description text_margin text_small" },
              [_vm._v(_vm._s(_vm.i18n.sale_video_formats()))]
            ),
            _vm._v(" "),
            _vm.form.youtubeId
              ? _c("div", { staticClass: "video-added__item" }, [
                  _c("iframe", {
                    staticClass: "video-frame video-frame_short",
                    attrs: {
                      src: "https://www.youtube.com/embed/" + _vm.form.youtubeId
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "video-added__item-del",
                      on: {
                        click: function($event) {
                          return _vm.deleteVideo("youtubeId")
                        }
                      }
                    },
                    [
                      _c("md-icon", {
                        attrs: { "md-src": "/static/img/cancel_icon.svg" }
                      }),
                      _vm._v(" "),
                      _c(
                        "span",
                        { staticClass: "text_x_small text_description" },
                        [_vm._v(_vm._s(_vm.i18n.lbl_delete()))]
                      )
                    ],
                    1
                  )
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("textarea-field", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: "max:2000",
                expression: "'max:2000'"
              }
            ],
            staticClass: "field_large",
            attrs: {
              name: "sale-description",
              id: "sale-description",
              label: _vm.i18n.sale_campaign_description(),
              disabled: _vm.form.convert,
              errorMessage: _vm.errorMessage("recipient")
            },
            model: {
              value: _vm.form.shortDescription,
              callback: function($$v) {
                _vm.$set(_vm.form, "shortDescription", $$v)
              },
              expression: "form.shortDescription"
            }
          }),
          _vm._v(" "),
          _c("input-field", {
            staticClass: "field_large",
            attrs: {
              name: "sale-video-description",
              id: "sale-video-description",
              label: _vm.i18n.sale_add_video(),
              placeholder: _vm.i18n.sale_add_video_label()
            },
            model: {
              value: _vm.videoDescription,
              callback: function($$v) {
                _vm.videoDescription = $$v
              },
              expression: "videoDescription"
            }
          }),
          _vm._v(" "),
          _vm.videoDescription
            ? _c("iframe", {
                staticClass: "video-frame",
                attrs: {
                  src:
                    "https://www.youtube.com/embed/" +
                    _vm.getYoutubeId(_vm.videoDescription)
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "md-button",
            {
              staticClass: "md-primary",
              on: {
                click: function($event) {
                  return _vm.addVideo()
                }
              }
            },
            [_vm._v(_vm._s(_vm.i18n.lbl_add_more()))]
          ),
          _vm._v(" "),
          _vm.form.videoDescriptionArray.length !== 0
            ? _c(
                "div",
                { staticClass: "video-added__wrap" },
                [
                  _c("div", [_vm._v(_vm._s(_vm.i18n.lbl_added_video()))]),
                  _vm._v(" "),
                  _vm._l(_vm.form.videoDescriptionArray, function(item, i) {
                    return _c(
                      "div",
                      { key: i, staticClass: "video-added__item" },
                      [
                        _c("iframe", {
                          staticClass: "video-frame",
                          attrs: {
                            src:
                              "https://www.youtube.com/embed/" +
                              _vm.form.videoDescriptionArray[i]
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "video-added__item-del",
                            on: {
                              click: function($event) {
                                return _vm.deleteVideo(i)
                              }
                            }
                          },
                          [
                            _c("md-icon", {
                              attrs: { "md-src": "/static/img/cancel_icon.svg" }
                            }),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "text_x_small text_description" },
                              [_vm._v(_vm._s(_vm.i18n.lbl_delete()))]
                            )
                          ],
                          1
                        )
                      ]
                    )
                  })
                ],
                2
              )
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "btn-wrap column" },
        [
          _c(
            "md-button",
            {
              staticClass: "btn md-primary",
              attrs: { type: "submit", disabled: _vm.isPending }
            },
            [_vm._v("\n      " + _vm._s(_vm.i18n.sale_next_step()) + "\n    ")]
          ),
          _vm._v(" "),
          _c(
            "md-button",
            {
              staticClass: "simple-link arrow_back",
              on: {
                click: function($event) {
                  return _vm.stepBack()
                }
              }
            },
            [_vm._v("\n      " + _vm._s(_vm.i18n.lbl_go_back_2()) + "\n    ")]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c34101a0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c34101a0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/app/saleCreation/steps/Step.Default.vue
// module id = cT/F
// module chunks = 1